import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ButtonGroup, Modal } from '../../../../../components'
import { COUNTRY } from '../../../../../utils/constants'
import { useModal } from '../../../../../utils/hooks'
import { countryOptions } from '../../../common/json/staticData.json'
import { inputActions, inputSlice, selectInputState } from '../../../store/slices/input.slice'
import omit from 'lodash/omit'
import {
  BUILDING_CODE,
  HOLDOWN_FASTENERS,
  POST_BASE_FASTENERS_TYPE,
  POST_THICKNESS_POST_BASE_DEFAULT,
  POST_WIDTH_POST_BASE_DEFAULT,
} from '../../../common/constants'

const CountrySelection = ({ onChange }) => {
  const dispatch = useDispatch()
  const [show, toggleModal] = useModal(false)
  const inputState = useSelector(selectInputState)
  const {
    foundationDesign,
    holdownDesign,
    postBaseDesign,
    settings: { country },
  } = inputState

  const countryIcon = useMemo(() => {
    return countryOptions.find((element) => element.value === country).imgSrc || ''
  }, [country])

  const onChangeCountry = (name, value) => {
    // foundationDesign always reset on country change
    const keepValueItems = ['holdownDesign', 'postBaseDesign']
    const resetState = omit(inputSlice.getInitialState(), keepValueItems)

    const payload = {
      ...resetState,
      holdownFastenersType: [HOLDOWN_FASTENERS.ALL],
      postBaseFastenersType: [POST_BASE_FASTENERS_TYPE.ALL],
      settings: {
        ...resetState.settings,
        [name]: value,
        isUSA: value === COUNTRY.USA,
        buildingCode: BUILDING_CODE[value],
      },
    }

    // When foundationDesign is the only selected, fallback to holdownDesign
    if (foundationDesign && !holdownDesign) {
      payload.holdownDesign = true
    }

    if (postBaseDesign) {
      payload.postWidth = POST_WIDTH_POST_BASE_DEFAULT
      payload.postThickness = POST_THICKNESS_POST_BASE_DEFAULT
    }

    dispatch(inputActions.updateCalculation(payload))
    toggleModal()
    onChange?.({ name, value })
  }

  return (
    <>
      <a role="button" onClick={toggleModal} className="country-btn">
        <img src={countryIcon} />
      </a>

      <Modal
        show={show}
        onHide={toggleModal}
        className="-country-selector"
        header={
          <Modal.Header closeButton>
            <h3>Select Your Country</h3>
          </Modal.Header>
        }
      >
        <ButtonGroup
          className="buttonGroup row -skinny -subAppSelector country-modal-btn"
          colClassName="col-xxs-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 -skinny"
          name="country"
          value={country}
          options={countryOptions}
          onChange={onChangeCountry}
        />
      </Modal>
    </>
  )
}

export default CountrySelection
